
import { useTranslation } from 'react-i18next';

interface LanguageToggleProps {
  variant?: 'light' | 'dark';
}

const LanguageToggle = ({ variant = 'light' }: LanguageToggleProps) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const toggleLanguage = () => {
    const newLang = currentLang === 'en' ? 'es' : 'en';
    i18n.changeLanguage(newLang);
  };

  const baseClasses = 'flex items-center gap-2 px-3 py-2 border-2 font-sans text-xs font-bold uppercase tracking-wider transition-all cursor-pointer';
  
  const variantClasses = variant === 'light'
    ? 'border-cream/30 text-cream hover:border-orange-burnt hover:text-orange-burnt'
    : 'border-leather-dark/30 text-leather-dark hover:border-orange-burnt hover:text-orange-burnt';

  return (
    <button
      onClick={toggleLanguage}
      className={`${baseClasses} ${variantClasses}`}
      aria-label={currentLang === 'en' ? 'Cambiar a Español' : 'Switch to English'}
    >
      <i className="ri-translate-2 text-sm"></i>
      <span>{currentLang === 'en' ? 'ES' : 'EN'}</span>
    </button>
  );
};

export default LanguageToggle;
